export const MONGO_ERRORS = {
  DUPLICATE_KEY: "duplicate_key",
};
